import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueRouter from "vue-router";
import routes from './routes';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'es6-promise/auto'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'

Vue.prototype.$http = axios;
Vue.prototype.$api_url = "https://defibwebapi-env.eba-5mktsqfm.eu-west-1.elasticbeanstalk.com/api/";

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueCookies);
Vue.$cookies.config('7d')

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

const router = new VueRouter({routes});

const store = new Vuex.Store({
  state: {
    deviceSerial: null,
    cprData: {
      cprValues: {
        inTargetRate: 0,
        inTargetDepth: 0,
        total: 0,
      },
      referenceValues: {
        minRate: 0,
        maxRate: 0,
        minDepth: 0,
        maxDepth: 0
      },
      sessionData: {
        compressionCycles: [
          {
            compressions: [
              {
                rate: 0,
                depth: 0,
                releaseVelocity: 0
              }
            ]
          }
        ]
      }

    },
  },
  mutations: {
    cprDataChanged(state, data){
      state.cprData = data;
    },
    setDeviceSerial(state, serial){
      state.deviceSerial = serial;
    }
  },
  getters: {
    cprData: state => state.cprData,
    deviceSerial: state => state.deviceSerial,
  }
})


new Vue({
  el: '#app',
  data: {
    serialnumbers: ['AX18E013810', 'AX18E013811', 'AX18E016666'],
  },
  render: h => h(App),
  router,
  store,
});



// WEBPACK FOOTER //
// ./src/main.js